/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API40565Req {
  
  /** 是否切换为新平台 */
  isNewPlatform?: boolean;
  /** 版本回退的原因 */
  msg?: string;
};



export interface API40565Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 40565 保存用户切换平台记录

export interface IUsePostAPI40565Return {
  /** 保存用户切换平台记录: 接口请求状态 */
  isAPI40565Loading: boolean;
  /** 保存用户切换平台记录: 接口请求返回数据 */
  dataAPI40565: API40565Res;
  /**  保存用户切换平台记录: 接口数据请求方法 */
  fetchAPI40565Data:  (inputs: API40565Req, config?: YWRequestConfig) => Promise<API40565Res>;
  /** 保存用户切换平台记录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI40565 = ():IUsePostAPI40565Return => {
  let isMount = true;
  const [isAPI40565Loading, setIsAPI40565Loading] = useState(false);
  const [dataAPI40565, setDataAPI40565] = useState<API40565Res>({} as API40565Res);
  const requestUrl = `${basePath}/ywwl-admin/user/turn/platform`;

  const fetchAPI40565Data = async (inputs: API40565Req, config?: YWRequestConfig): Promise<API40565Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API40565Req>) || {}) as API40565Req;
    
  
    if ( isMount ) {
      setIsAPI40565Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API40565Res>(`${basePath}/ywwl-admin/user/turn/platform`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI40565(res || {} as API40565Res);
        setIsAPI40565Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI40565Loading(false);
      }
      return false as unknown as API40565Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI40565Loading,
    dataAPI40565,
    fetchAPI40565Data,
    requestUrl,
  }
}

